import { create } from 'zustand';
import { EventRegistrationOptionAvailability } from 'src/generated/api/dsv-public/model';

type OptionAvailability = {
  remainingSelections: number;
  sessionSelections: number;
};

type SessionStore = {
  sessionId: string | undefined;
  availability: Record<number, OptionAvailability>;
  setSession: (sessionId: string, optionAvailability: EventRegistrationOptionAvailability[]) => void;
  updateAvailability: (updates: EventRegistrationOptionAvailability[]) => void;
  clearSession: () => void;
};

const toAvailabilityMap = (items: EventRegistrationOptionAvailability[]): Record<number, OptionAvailability> =>
  Object.fromEntries(
    items.map(a => [a.optionId, { remainingSelections: a.remainingSelections, sessionSelections: a.sessionSelections }])
  );

export const useSessionStore = create<SessionStore>(set => ({
  sessionId: undefined,
  availability: {},
  setSession: (sessionId, optionAvailability) =>
    set({
      sessionId,
      availability: toAvailabilityMap(optionAvailability),
    }),
  updateAvailability: updates =>
    set(prev => ({
      availability: {
        ...prev.availability,
        ...toAvailabilityMap(updates),
      },
    })),
  clearSession: () => set({ sessionId: undefined, availability: {} }),
}));
